import { useEffect } from 'react';
import {
  enterManagedViewLargeListMode,
  leaveManagedViewLargeListMode,
} from '@/utils/managedImageViewLoadQueue';

/** 超过该组数/行数时进入大列表降并发，避免 HMAC view 队列堵死白底 */
export const DETAIL_PAGE_LARGE_LIST_THRESHOLD = 8;

/**
 * 详情页多组图片：挂载期间降低受管 view 并发（与图片空间虚拟列表一致）。
 * @param {boolean} enabled
 */
export function useDetailPageLargeListMode(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    enterManagedViewLargeListMode();
    return () => leaveManagedViewLargeListMode();
  }, [enabled]);
}
